import _possibleConstructorReturn from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _classCallCheck from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { queueMicrotask } from './queueMicrotask';
// eslint-disable-next-line no-restricted-syntax
export var Observable = /*#__PURE__*/function () {
  function Observable(onFirstSubscribe) {
    _classCallCheck(this, Observable);
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }
  return _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      var _this = this;
      this.addObserver(observer);
      return {
        unsubscribe: function unsubscribe() {
          return _this.removeObserver(observer);
        }
      };
    }
  }, {
    key: "notify",
    value: function notify(data) {
      this.observers.forEach(function (observer) {
        return observer(data);
      });
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.push(observer);
      if (this.observers.length === 1 && this.onFirstSubscribe) {
        this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers = this.observers.filter(function (other) {
        return observer !== other;
      });
      if (!this.observers.length && this.onLastUnsubscribe) {
        this.onLastUnsubscribe();
      }
    }
  }]);
}();
export function mergeObservables() {
  for (var _len = arguments.length, observables = new Array(_len), _key = 0; _key < _len; _key++) {
    observables[_key] = arguments[_key];
  }
  return new Observable(function (globalObservable) {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
}
// eslint-disable-next-line no-restricted-syntax
export var BufferedObservable = /*#__PURE__*/function (_Observable) {
  function BufferedObservable(maxBufferSize) {
    var _this2;
    _classCallCheck(this, BufferedObservable);
    _this2 = _callSuper(this, BufferedObservable);
    _this2.maxBufferSize = maxBufferSize;
    _this2.buffer = [];
    return _this2;
  }
  _inherits(BufferedObservable, _Observable);
  return _createClass(BufferedObservable, [{
    key: "notify",
    value: function notify(data) {
      this.buffer.push(data);
      if (this.buffer.length > this.maxBufferSize) {
        this.buffer.shift();
      }
      _superPropGet(BufferedObservable, "notify", this, 3)([data]);
    }
  }, {
    key: "subscribe",
    value: function subscribe(observer) {
      var _this3 = this;
      var closed = false;
      var subscription = {
        unsubscribe: function unsubscribe() {
          closed = true;
          _this3.removeObserver(observer);
        }
      };
      queueMicrotask(function () {
        var _iterator = _createForOfIteratorHelper(_this3.buffer),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var data = _step.value;
            if (closed) {
              return;
            }
            observer(data);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (!closed) {
          _this3.addObserver(observer);
        }
      });
      return subscription;
    }
    /**
     * Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
     * needed anymore. This can be seen as a performance optimization, and things will work probably
     * even if this method isn't called, but still useful to clarify our intent and lowering our
     * memory impact.
     */
  }, {
    key: "unbuffer",
    value: function unbuffer() {
      var _this4 = this;
      queueMicrotask(function () {
        _this4.maxBufferSize = _this4.buffer.length = 0;
      });
    }
  }]);
}(Observable);